const ProtocolAssociatedAccount = resolve => {
    import(/* webpackChunkName: 'associatedAccount' */'../views/protocol/associatedAccount').then(associatedAccount => {
        resolve(associatedAccount)
    })
}

const AppUserPrivacyPolicy = resolve => {
    import(/* webpackChunkName: 'appUserPrivacyPolicy' */'../views/protocol/appUserPrivacyPolicy').then(appUserPrivacyPolicy => {
        resolve(appUserPrivacyPolicy)
    })
}

const AppAuth = resolve => {
    import(/* webpackChunkName: 'appAuth' */'../views/protocol/appAuth').then(appAuth => {
        resolve(appAuth)
    })
}

const UserServicePolicy = resolve => {
    import(/* webpackChunkName: 'appAuth' */'../views/protocol/userServicePolicy').then(userServicePolicy => {
        resolve(userServicePolicy)
    })
}

export default [
    {
        path: '/protocol/associatedaccount',
        name: 'associatedAccount',
        component: ProtocolAssociatedAccount,
        meta: {
            title: '关联账户服务授权协议'
        }
    },
    {
        path: '/protocol/appUserPrivacyPolicy',
        name: 'appUserPrivacyPolicy',
        component: AppUserPrivacyPolicy,
        meta: {
            title: '用户隐私保护政策'
        }
    },
    {
        path: '/protocol/appAuth',
        name: 'appAuth',
        component: AppAuth,
        meta: {
            title: '授权管理'
        }
    },
    {
        path: '/protocol/userServicePolicy',
        name: 'userServicePolicy',
        component: UserServicePolicy,
        meta: {
            title: '拍拍贷用户服务协议'
        }
    }
]
